module.exports = __webpack_public_path__ + "img/notification-time-icon.fcbb7b38.svg";